exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Countdown {\n  min-width: 11.3em;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  color: #EE5353;\n  padding: 4px;\n  font-size: 12px;\n  font-size: 14px;\n  font-weight: 600;\n}\n", ""]);
